import { useMutation } from '@apollo/client';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { graphql } from '~/apollo/generated/v3';
import { Confirm } from '~/components/common/Confirm';
import { Tooltip } from '~/components/common/Tooltip';
import { Button } from '~/components/ui/button';
import type { RefetchQueries } from '~/utils/graphql';

export const DELETE_STUDY_ACCESS = graphql(`
  mutation DeleteStudyAccess($id: Int!) {
    deleteStudyAccess(id: $id)
  }
`);

export function DeleteStudyAccess({
  studyAccessId,
  companyName,
  refetchQueries,
}: {
  studyAccessId: number;
  companyName: string;
  refetchQueries: RefetchQueries;
}) {
  const [deleteStudyAccess, { loading }] = useMutation(DELETE_STUDY_ACCESS, {
    variables: { id: studyAccessId },
    refetchQueries,
  });

  async function handleDelete() {
    try {
      await deleteStudyAccess();
      toast.success('Study access revoked.');
    } catch (err) {
      console.log('Error deleting study access', err);
      toast.error('There was a problem revoking the study access.');
    }
  }

  return (
    <Confirm
      onConfirm={handleDelete}
      text={`Study access to ${companyName} will be revoked.`}
    >
      {showConfirm => (
        <Tooltip message={`Revoke access from ${companyName}`}>
          <Button
            type="button"
            color="ghost"
            size="xs"
            onClick={showConfirm}
            loading={loading}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </Tooltip>
      )}
    </Confirm>
  );
}
